import { render, staticRenderFns } from "./ChatAgent.vue?vue&type=template&id=38e3414c"
import script from "./ChatAgent.vue?vue&type=script&lang=js"
export * from "./ChatAgent.vue?vue&type=script&lang=js"
import style0 from "./ChatAgent.vue?vue&type=style&index=0&id=38e3414c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports